import { useMutation } from "@tanstack/react-query";
import { useMemo } from "react";
import { postAuthMethod } from "../../modules/helper";

function ErrorHandler(props) {
  const { mutate } = useMutation({
    mutationKey: ["newErrorLog"],
    mutationFn: data => postAuthMethod("/error", data).then(res => res.data),
  });

  useMemo(() => {
    window.onerror = (message, source, lineno, colno, error) => {
      mutate({
        message: error.message,
        stack: error.stack,
        name: error.name,
        project: 3,
      });
    };
  }, []);

  return props.children;
}

export default ErrorHandler;
